import { render, staticRenderFns } from "./service-package.vue?vue&type=template&id=814b5402&scoped=true&"
import script from "./service-package.vue?vue&type=script&lang=js&"
export * from "./service-package.vue?vue&type=script&lang=js&"
import style0 from "./service-package.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./service-package.vue?vue&type=style&index=1&id=814b5402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814b5402",
  null
  
)

export default component.exports